import React from 'react';
import LineGraph from './LineGraph';
import BarGraph from './BarGraph';
import PieGraph from './PieGraph';
import Modal from '../../../shared/modals/Modal';
import { ModalCloseButton } from '../../../shared/modals/Modal';

import { ReactComponent as ExpandIcon } from '../../../assets/icons/expand.svg';
import { ReactComponent as LineIcon } from '../../../assets/icons/graph.svg';
import { ReactComponent as BarIcon } from '../../../assets/icons/bar.svg';
import { ReactComponent as PieIcon } from '../../../assets/icons/pie.svg';

const TrafficGraph = ({specs, setReady, which, setWhich}) => {
  const [expanded, setExpanded] = React.useState(false);
  const totalBotClicks = specs.values.bot.reduce((a, b) => a + b, 0);
  const totalHumanClicks = specs.values.human.reduce((a, b) => a + b, 0);
  const totalClicks = totalBotClicks + totalHumanClicks;
  const humanPercentage = totalClicks > 0 ? (totalHumanClicks / totalClicks) * 100 : 0;
  const botPercentage = totalClicks > 0 ? (totalBotClicks / totalClicks) * 100 : 0;

  const renderModeButton = (mode, label, Icon) => (
    <button
      type="button"
      className={`control-btn traffic-graph__mode-btn ${which === mode ? 'is-active' : ''}`}
      onClick={() => setWhich(mode)}
      aria-label={label}
    >
      <Icon className="icon base" />
    </button>
  );

  const renderSummary = () => (
    <div className="traffic-graph__summary">
      <div className="traffic-graph__summary-item">
        <span className="chart-label__swatch chart-label__swatch--human" />
        <span className="traffic-graph__summary-label">Human Traffic</span>
        <span className="traffic-graph__summary-metric">
          <span className="metric-value-primary">{totalHumanClicks.toLocaleString()}</span>
          <span className="metric-value-separator">|</span>
          <span className="metric-value-secondary">{humanPercentage.toFixed(2)}%</span>
        </span>
      </div>
      <div className="traffic-graph__summary-item">
        <span className="chart-label__swatch chart-label__swatch--bot" />
        <span className="traffic-graph__summary-label">Bot Traffic</span>
        <span className="traffic-graph__summary-metric">
          <span className="metric-value-primary">{totalBotClicks.toLocaleString()}</span>
          <span className="metric-value-separator">|</span>
          <span className="metric-value-secondary">{botPercentage.toFixed(2)}%</span>
        </span>
      </div>
    </div>
  );

  const renderChartContent = (className = '') => (
    <div className={`traffic-graph__chart${className ? ` ${className}` : ''}${which === 'pie' ? ' is-pie' : ''}`}>
      {which === 'line' && (
        <div className="chart-wrap">
          <LineGraph specs={specs} showLegend={false} />
        </div>
      )}
      {which === 'bar' && (
        <div className="chart-wrap">
          <BarGraph specs={specs} setReady={setReady} showLegend={false} />
        </div>
      )}
      {which === 'pie' && <PieGraph specs={specs} />}
    </div>
  );

  const inlineGraph = (
    <div className="traffic-graph">
      <div className="traffic-graph__header">
        <span className="chart-title">{specs.title}</span>
        <button
          type="button"
          className="control-btn traffic-graph__expand-btn"
          aria-label={`Expand ${specs.title}`}
          onClick={() => setExpanded(true)}
        >
          <ExpandIcon className="icon sm image" />
        </button>
      </div>
      {renderSummary()}
      <div className="traffic-graph__body">
        <div className="traffic-graph__modes">
          {renderModeButton('bar', 'Bar mode', BarIcon)}
          {renderModeButton('line', 'Line mode', LineIcon)}
          {renderModeButton('pie', 'Pie mode', PieIcon)}
        </div>
        {renderChartContent()}
      </div>
    </div>
  );

  const modalGraph = (
    <div className="traffic-graph traffic-graph--modal">
      <div className="traffic-graph__header">
        <span className="chart-title">{specs.title}</span>
        <div className="traffic-graph__mode-toolbar">
          {renderModeButton('bar', 'Bar mode', BarIcon)}
          {renderModeButton('line', 'Line mode', LineIcon)}
          {renderModeButton('pie', 'Pie mode', PieIcon)}
        </div>
      </div>
      {renderSummary()}
      {renderChartContent('traffic-graph__chart--modal')}
    </div>
  );

  return (
    <div className="traffic-graph-frame">
      {expanded && (
        <Modal isOpen={expanded}
               onClose={() => setExpanded(false)}
               className="modal--wide modal--full-height">
          <div className="modal">
            <div className="modal__header">
              <h3 className="margin-none">{specs.title}</h3>
              <ModalCloseButton onClick={() => setExpanded(false)} label="Close chart modal" />
            </div>
            <div className="modal__body">
              <div className="site-overview">
                {modalGraph}
              </div>
            </div>
          </div>
        </Modal>
      )}
      {!expanded && inlineGraph}
    </div>
  );
}

export default TrafficGraph;
